import { CheckboxStateEnum } from "@app/shared/qes-standards/forms/Checkbox";
import React from "react";

enum VolumeReportsWizardContextSteps {
  "SelectServiceArea",
  "SelectSpecialty",
  "SelectProjects",
  "Filters",
  "Configure",
}

interface VolumeReportsCounty {
  isChecked?: boolean;
  displayName: string;
  isVisible?: boolean;
  namespacePath: string;
  serviceAreaValue: number;
}

interface VolumeReportsSpecialty {
  isChecked?: boolean;
  displayName: string;
  isVisible?: boolean;
  namespacePath: string;
  specialtyGroupCode: string;
}

interface VolumeReportsProject {
  customProjectId: number;
  exceptionCount: number;
  gapCount: number;
  hasNetNewProviders: boolean;
  isChecked?: boolean;
  isNCPEnabled: boolean;
  isVisible?: boolean;
  projectName: string;
  tags?: string[];
  templateName: string;
  isUnpublishedResult: boolean;
  rowIsDisabled: boolean;
  showNextClosestProviders: boolean;
  isDualMembershipProject: boolean;
  countySpecialtyGroupCount: number;
  networkId: number;
  networkName: string;
}

interface VolumeReportsState {
  checkboxState?: CheckboxStateEnum;
  childServiceAreas: VolumeReportsCounty[];
  displayName: string;
  isVisible?: boolean;
  namespacePath: string;
}

interface TagLookup {
  [tagName: string]: VolumeReportsProject[];
}

const countiesFilterRadioOptions = [
  "Current Service Area",
  "Opportunities to Expand",
] as const;
type CountiesFilterRadioOptionsType = typeof countiesFilterRadioOptions[number];

interface WizardStepProps {
  pageIsValid?: React.Dispatch<React.SetStateAction<boolean>>;
}

const reportFormatOptions = ["CSV File", "Pipe-delimited Text", "Tab-delimited Text"] as const;
type ReportFormatOptionsType = typeof reportFormatOptions[number];

const reportFilterOptions = ["Default Format", "MA HSD Format", "MMP HSD Format", "CCIIO PPF Report", "Distinct Servicing Providers"] as const;
type ReportFilterOptionsType = typeof reportFilterOptions[number];

export {
  countiesFilterRadioOptions,
  CountiesFilterRadioOptionsType,
  reportFilterOptions,
  ReportFilterOptionsType,
  reportFormatOptions,
  ReportFormatOptionsType,
  TagLookup,
  VolumeReportsCounty,
  VolumeReportsProject,
  VolumeReportsSpecialty,
  VolumeReportsState,
  VolumeReportsWizardContextSteps,
  WizardStepProps,
};
